var map = {
	"./balla.png": 810,
	"./cyath.png": 852,
	"./dehtat.png": 32,
	"./dokrahm.png": 261,
	"./kronsh.png": 490,
	"./mewan.png": 572,
	"./ooltha.png": 167,
	"./plague-keewar.png": 568,
	"./plague-kripath.png": 281,
	"./rabvee.png": 474,
	"./sepfahn.png": 520
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 405;